import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Navbar from '../../component/navbar';
import { useAppSelector } from '../../store/hooks';
import { SideBar } from './component/sideBar';
import { BackgroundContainer, MainContainer } from './styles';

const Dashboard = () => {
  const auth = useAppSelector((state) => state.auth);
  const location = useLocation();
  if (!auth.user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return (
    <BackgroundContainer>
      <SideBar />
      <MainContainer>
        <Navbar />
        <Outlet />
      </MainContainer>
    </BackgroundContainer>
  );
};

export default Dashboard;
